module.exports = __webpack_public_path__ + "static/media/6.a96388ef.png";